import { PersonalContentRouting } from '@aipb/gulliver/personal-content/routing';
import { openUrl } from '@aipb/shared/util/routing';
import { UseCase } from '@aipb/shared/util/usecase';
import { inject, Injectable } from '@angular/core';

interface OpenCollectionParams {
  id: string;
  openInNewTab?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class OpenCollectionUseCase implements UseCase<OpenCollectionParams> {
  private personalContentRouting = inject(PersonalContentRouting);

  execute(data: OpenCollectionParams) {
    if (data.openInNewTab) {
      openUrl(this.personalContentRouting.collectionSingleAbsUrl(data.id));
      return;
    }

    this.personalContentRouting.collectionSingle(data.id);
  }
}
